<template>
<div>
	<!-- 标题 -->
	<div class="page-title">用户设置</div>
	<div style="padding: 30px 0;width: 70vw;margin: auto;">
		<!-- <div class="form-cell-box">
			<div class="class-title">用户名<span class="required-hint">*</span></div>
			
			<div :style="{'width': widths + 'px'}">{{infoData.username}}</div>
		</div> -->
		
		<div class="form-cell-box">
			<div class="class-title">名称<span class="required-hint">*</span></div>
				
			<!-- <a-input v-model="infoData.name" placeholder="请输入名称"  :style="{'width': widths + 'px'}"  /> -->
			<div :style="{'width': widths + 'px'}">{{infoData.name}}</div>
		</div>
		
		<!-- <div class="form-cell-box">
			<div class="class-title">绑定飞书</div>
				
			<div>绑定飞书</div>
		</div> -->
		
		<!-- <div class="form-cell-box">
			<div class="class-title">角色<span class="required-hint">*</span></div>
			<a-select
				:value="infoData.roleValue"
			    mode="multiple"
			    :style="{'width': widths + 'px'}"
			    placeholder="请选择"
			    @change="handleChangeB"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
				allowClear
			  >
			 
			    <a-select-option v-for="(value,key) in roleList" :key="key" :value="key">
			      {{value}}
			    </a-select-option>
			</a-select>
		</div> -->
		
		<!-- <div class="form-cell-box">
			<div class="class-title">常用登录城市<span class="required-hint">*</span></div>
				
			<a-input v-model="infoData.city" placeholder="请输入" :style="{'width': widths + 'px'}" />
		</div> -->
		<!-- <div style="display: flex;margin-bottom: 20px;margin-top: -15px;">
			<div style="width: 100px;text-align: right;margin-right: 25px;">提交格式--英逗号做分隔：</div>
			<div>
				<div>长沙</div>
				<div>长沙,北京</div>
				<div>长沙,北京,杭州</div>
			</div>
			
		</div> -->
		
		<!-- <div class="form-cell-box">
			<div class="class-title">头像</div>
			<div style="display: flex;align-items: center;">
				<a-upload
					accept="image/*"
				    name="file"
				    list-type="picture-card"
				    class="avatar-uploader"
				    :show-upload-list="false"
				    :action="`${$http.excel_url}api/common/upload-image`"
					:data="{
						'name': 'Image.png',
						'type': 1
					}"
					:headers="{
						'Authorization': headers_token
					}"
					:withCredentials="true"
					method="post" 
				    :before-upload="beforeUpload"
				    @change="uploadChange"
				  >
					<img v-if="imageUrl" :src="imageUrl" :style="{'width': widths-20 + 'px'}" style="height: 240px;object-fit: contain;box-sizing: border-box;" alt="avatar" />
				    <div v-else :style="{'width': widths-20 + 'px'}" style="height: 240px;display: flex;align-items: center;flex-direction: column;justify-content: center;box-sizing: border-box;">
				      <a-icon :type="loading ? 'loading' : 'plus'" style="font-size: 26px;" />
				      <div class="" style="margin-top: 15px;">
				        选择图片
				      </div>
				    </div>
				</a-upload>
				<a-button @click="delTopImg" v-if="imageUrl" style="margin-left: 30px;" size="small" type="danger">删除</a-button>
			</div>
		</div> -->
		
		<div class="form-cell-box">
			<div class="class-title">原登录密码</div>
				
			<a-input-password v-model="x_old_password" placeholder="请输入原登录密码" :style="{'width': widths + 'px'}"  />
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">新登录密码</div>
				
			<a-input-password v-model="x_password" placeholder="请输入新登录密码 ( 8-20位, 需包含大写、字母、数字、符号 ) " :style="{'width': widths + 'px'}"  />
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">确认登录密码</div>
				
			<a-input-password v-model="x_password_confirmation" placeholder="请输入确认登录密码" :style="{'width': widths + 'px'}"  />
		</div>
		
		<!-- <div class="form-cell-box">
			<div class="class-title">原绩效密码</div>
				
			<a-input-password v-model="x_old_reward_password" placeholder="请输入原绩效密码" :style="{'width': widths + 'px'}"  />
		</div> -->
		
		<!-- <div class="form-cell-box">
			<div class="class-title">新绩效密码</div>
				
			<a-input-password v-model="x_reward_password" placeholder="请输入新绩效密码" :style="{'width': widths + 'px'}"  />
		</div> -->
		
		<!-- <div class="form-cell-box">
			<div class="class-title">确认绩效密码</div>
				
			<a-input-password v-model="x_reward_password_confirmation" placeholder="请输入确认绩效密码" :style="{'width': widths + 'px'}"  />
		</div> -->
		
		<div class="form-cell-box" style="margin-top: 30px;padding-left: 115px;">
			<a-button @click="addRequest" :loading="search_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
			<a-button @click="addCloseDrawer">返回</a-button>
		</div>
	</div>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { getUserInfo, UserSelectRole, UserEdit, getUserEditPwd } from '@/request/api'
export default {
	name: 'userInfor_',
	components: {
		
	},
	data() {
		return {
			x_old_password: "", // 原登录密码
			x_password: "", // 新登录密码
			x_password_confirmation: "", // 确认登录密码
			x_old_reward_password: "", // 原绩效密码
			x_reward_password: "", // 新绩效密码
			x_reward_password_confirmation: "", // 确认绩效密码
			
			widths: 630, // 内容的宽度
			
			search_button_loading: false,
			
			// 头像上传相关参数
			headers_token: "", // 图片上传用的token
			loading: false,
			imageUrl: '',
			
			infoData: {}, // 用户信息
			roleList: {}, // 角色下拉列表
			
			user_id: "", // 用户id
			
			search_button_loading: false,
		}
	},
	mounted(){
		let that = this
		
		// that.search_button_loading = true
		
		that.widths = Math.floor(document.body.clientWidth*0.7 - 210)
		console.log("that.widths",that.widths);
		
		// 图片上传用的token
		that.headers_token = 'Bearer ' + localStorage.getItem("access_token")
		
		that.infoData.name = localStorage.getItem("user_name_identity") || '未知用户'
		
		let u_id = localStorage.getItem("user_id_storage")
		that.user_id = u_id
		console.log("u_id",u_id);
		// getUserInfo({
		// 	id: u_id
		// }).then(res=>{
		// 	that.search_button_loading = false
		// 	console.log("获取信息",res);
		// 	if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
		// 		that.$message.success('获取信息成功');
		// 		let iii = res.data.data.info
		// 		iii.roleValue = Object.keys(iii.role) || []
		// 		// console.log("iii",iii);
		// 		that.infoData = iii
		// 	}
		// 	else {
		// 		if(res.data.code == 401){ // 未登录
		// 			localStorage.removeItem("access_token");
		// 			that.$router.replace({name: 'login',params: {type:'not_log'}})
		// 		}
		// 		else {
		// 			that.$message.error(`错误：${res.data.msg}`);
		// 		}
		// 	}
		// })
		
		// UserSelectRole().then(res=>{
		// 	let data = res.data.data.list
		// 	let k_data = Object.keys(data)
		// 	let r_data = []
		// 	k_data.forEach(res=>{
		// 		let obj = {
		// 			key : res,
		// 			value : data[res]
		// 		}
		// 		r_data.push(obj)
		// 	})
		// 	that.roleList = res.data.data.list
		// })
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 角色下拉
		handleChangeB(value) {
			this.infoData.roleValue = value
		    console.log(value);
		},
		// 顶部图片上传 限制用户上传的图片格式和大小。
		beforeUpload(file){
			console.log("beforeUpload",file);
				
			// if(this.add_wx_kf_account_id){
				  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
				  if (!isJpgOrPng) {
					this.$message.error('You can only upload JPG file!');
				  }
				  const isLt2M = file.size / 1024 / 1024 < 2;
				  if (!isLt2M) {
					this.$message.error('Image must smaller than 2MB!');
				  }
				  return isJpgOrPng && isLt2M;
			// }
			// else {
			// 	this.$message.warning('请先选择企业');
			// }
		},
		uploadChange(info){
			// console.log("图片请求",info);
			let that = this
			if (info.file.status === 'uploading') {
					this.loading = true;
					return;
			}
			if (info.file.status === 'done') {
				console.log("图片请求done",info);
				if(info.file.response){ // 图片上传成功，有内容返回
					// this.add_wx_kf_media_id = info.file.response.data.media_id
					that.r_top_image = info.file.response.data.path
					that.imageUrl = info.file.response.data.url
					that.loading = false
					// getBase64(info.file.originFileObj, imageUrl => {
					//   this.imageUrl = imageUrl;
					//   this.loading = false;
					// });
				}
				else {
					this.imageUrl = ""
					this.loading = false;
					this.$message.error(`错误：图片上传失败`);
				}
					
				
			}
			
			if (info.file.status === 'error') { // 上传失败
				
				this.imageUrl = ""
				this.loading = false;
				this.$message.error(`错误：图片上传失败`);
			
			}
		},
		// 删除选择的图片
		delTopImg(){
			this.imageUrl = ""
			this.r_top_image = ""
		},
		addRequest(){
			let that = this
			if(!that.infoData.name){
				that.$message.warning('请填写名称');
			}
			// else if(that.infoData.roleValue.length < 1){
			// 	that.$message.warning('请选择角色');
			// }
			else if(!that.x_old_password){
				that.$message.warning('请填写：原登录密码');
			}
			else if(!that.x_password){
				that.$message.warning('请填写：新登录密码');
			}
			else if(!that.x_password_confirmation){
				that.$message.warning('请填写：确认登录密码');
			}
			else if(that.x_password != that.x_password_confirmation){
				that.$message.warning('新密码与确认新密码不一致');
			}
			else {
				that.search_button_loading = true
				
				let r_data = {
					// id: that.user_id, // 用户id
					// username: that.infoData.username, // 登录用户名
					// name: that.infoData.name, // 名称
					// city: that.infoData.city, // 常用登录城市
					// roles: that.infoData.roleValue, // 角色数组 例如：roles=[1,2] 角色id
					password: that.x_password, // 新密码
					password_confirmation: that.x_password_confirmation, // 密码确认
					// reward_password: that.x_reward_password, // 绩效密码
					// reward_password_confirmation: that.x_reward_password_confirmation, // 绩效密码确认
					password_origin: that.x_old_password, // 原来的登录密码
				}
				
				// UserEdit(r_data).then(res=>{
				// 	that.search_button_loading = false
				// 	console.log("确认",res);
				// 	if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
				// 		that.$message.success('操作成功');
				// 	}
				// 	else {
				// 		if(res.data.code == 401){ // 未登录
				// 			localStorage.removeItem("access_token");
				// 			that.$router.replace({name: 'login',params: {type:'not_log'}})
				// 		}
				// 		else {
				// 			that.$message.error(`错误：${res.data.msg}`);
				// 		}
				// 	}
				// })
				
				getUserEditPwd(r_data).then(res=>{
					that.search_button_loading = false
					console.log("修改密码",res);
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						that.$message.success('修改成功');
					}
					else {
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
				})
			}
			
		},
		addCloseDrawer(){
			this.$router.back()
		},
	}
}
</script>

<style scoped>
.form-cell-box {
	display: flex;
	align-items: center;
	margin-bottom: 25px;
}
.class-title {
	position: relative;
	font-size: 14px;
	margin-right: 25px;
	width: 90px;
	color: #333;
	text-align: right;
}

</style>